import { Editor } from "@tinymce/tinymce-react";

export default function RichTextEditor({
    value,
    onChange,
    height = 400,
}) {
    return (
        <Editor
            apiKey="tu8cxhxtbas5k2b0s1f68c8j4edobxodfyhyx8iivkrmmpdm"
            value={value}
            init={{
                height,
                menubar: false,
                plugins: [
                    "advlist autolink lists link charmap preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table help wordcount",
                ],
                toolbar:
                    "undo redo | blocks | " +
                    "bold italic underline | alignleft aligncenter alignright alignjustify | " +
                    "bullist numlist outdent indent | removeformat | help",
                paste_as_text: false,
                paste_data_images: true,
                valid_elements: "*[*]",
                extended_valid_elements:
                    "a[href|target=_blank],h2[style],blockquote,ul,li,strong,em,span[style],p[style]",
                content_style:
                    "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
            }}
            onEditorChange={onChange}
        />
    );
}
